module.exports = __webpack_public_path__ + "img/2.605c028d.png";